import React, { useState, useEffect } from "react";
import "./NewApplicationForm.css";
import qrImage from "./qr.jpg";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

function NewApplicationForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    dateOfBirth: "",
    age: "",
    gender: "",
    address: "",
    phoneNumber: "",
    guardianPhoneNumber: "",
    email: "",
    fatherName: "",
    fatherProfession: "",
    motherName: "",
    motherProfession: "",
    guardianName: "",
    annualIncome: "",
    previousSchoolName: "",
    previousSchoolAddress: "",
    previousSchoolContact: "",
    previousSchoolEmail: "",
    previousClass: "",
    reasonForTransfer: "",
    academicCertificates: "",
    sportsCertificates: "",
    photoId: null,
    idProof: null,
    addressProof: null,
    medicalConditions: "",
    medications: "",
    emergencyContact: "",
    doctorContact: "",
    bloodGroup: "",
    category: "",
    paymentTransactionId: "",
    paymentScreenshot: null,
  });

  // const [dialogOpen, setDialogOpen] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] });
  };

  const calculateAge = (dob) => {
    const birthYear = new Date(dob).getFullYear();
    const currentYear = new Date().getFullYear();
    const age = currentYear - birthYear;
    setFormData((prevData) => ({ ...prevData, age: age }));
  };

  const [emailError, setEmailError] = useState("");

const validateEmail = () => {
  if (formData.email && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
    setEmailError("Invalid email format");
  } else {
    setEmailError("");
  }
};

  

  const handleSubmit = async (e) => 
    {
    e.preventDefault();
    setLoading(true);

    const receiptData = {
      date: new Date().toLocaleDateString(),
      name: formData.fullName,
      fatherName: formData.fatherName,
      className: formData.previousClass || "N/A",
      rollNo: "N/A",
      admission: "2000",
      book: "1500",
      uniform: "1000",
      beltTieId: "500",
      tuition: "3000",
      exam: "800",
      van: "1200",
      others: "0",
      total: "10000",
      received: "10000",
    };
    console.log(formData);

    const receiptHTML = `
      <div style="display: flex; justify-content: space-between; padding: 10mm; box-sizing: border-box; width: 800px;">
        ${[1, 2].map(() => `
          <div style="width: 48%; border: 1px solid #000; padding: 10px; box-sizing: border-box; font-family: Arial, sans-serif; font-size: 12px;">
            <div style="font-size: 16px; font-weight: bold; text-align: center;">OXFORD CONVENT<br>ENGLISH MEDIUM SCHOOL, KHAJURI</div>
            <div style="text-align: center; font-size: 13px; margin-bottom: 10px;">KHAJURI - 585 314 - Tq. Aland Dist. Kalaburagi<br><strong>FEES RECEIPT</strong></div>

            <div style="display: flex; justify-content: flex-end;"><div>Date: ${formData.date}</div></div>
            <div>Name: ${formData.name}</div>
            <div>Father Name: ${receiptData.fatherName}</div>
            <div style="display: flex; justify-content: space-between;"><div>Class: ${receiptData.className}</div><div>Roll No: ${receiptData.rollNo}</div></div>

            <table style="width: 100%; margin-top: 10px; border-collapse: collapse;" border="1">
              <tr><th>Particulars</th><th>Amount</th></tr>
              <tr><td>Admission Fees</td><td>${receiptData.admission}</td></tr>
              <tr><td>Book Fees</td><td>${receiptData.book}</td></tr>
              <tr><td>Uniform Fees</td><td>${receiptData.uniform}</td></tr>
              <tr><td>Belt, Tie, & ID Card Fees</td><td>${receiptData.beltTieId}</td></tr>
              <tr><td>Tuition / Library Fees</td><td>${receiptData.tuition}</td></tr>
              <tr><td>Exam Fees</td><td>${receiptData.exam}</td></tr>
              <tr><td>School Van Fees</td><td>${receiptData.van}</td></tr>
              <tr><td>Others</td><td>${receiptData.others}</td></tr>
            </table>

            <div>Total Fees: ${receiptData.total}</div>
            <div>Received Amount: ${receiptData.received}</div>

            <div style="margin-top: 10px;">Note: 1st Sem Fees June&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IInd Sem Fees Oct.</div>
            <div style="text-align: right; margin-top: 20px;">Sign of Cashier/H.M</div>
          </div>
        `).join('')}
      </div>
    `;

    const hiddenDiv = document.createElement("div");
    hiddenDiv.innerHTML = receiptHTML;
    hiddenDiv.style.position = "absolute";
    hiddenDiv.style.left = "-9999px";
    document.body.appendChild(hiddenDiv);

    const canvas = await html2canvas(hiddenDiv);
    const imgData = canvas.toDataURL("image/png");

    const doc = new jsPDF("p", "mm", "a4");
    const pdfWidth = doc.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    const pdfBlob = doc.output("blob");
    const formDataToSend = new FormData();
    formDataToSend.append("pdf", pdfBlob, "application-receipt.pdf");
    Object.keys(formData).forEach((key) => {
      if(formData[key]) {
        formDataToSend.append(key, formData[key]);
      }
    });

    if (formData.photoId) formDataToSend.append("photoId", formData.photoId);
    if (formData.idProof) formDataToSend.append("idProof", formData.idProof);
    if (formData.paymentScreenshot) formDataToSend.append("paymentScreenshot", formData.paymentScreenshot);
    console.log(formDataToSend);
    fetch("https://oxfordconventschoolkhajuri.com//backend/src/send_email.php", {
      method: "POST",
      body: formDataToSend,
    })
      .then(async (res) => {
        const text = await res.text();
        console.log("Raw response:", text); // ✅ Log the raw response
        return text;
      })
      .then((result) => {
        console.log("Parsed response:", result);
        alert("Application Submitted and Email Sent!");
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        alert(`Failed to send email. ${err.message}`);
      })
      .finally(() => {
        setLoading(false);
        console.log("Fetch request completed.");
      });
    
  };

  // const handleCloseDialog = () => {
  //   setDialogOpen(false);
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="form-container">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
      {/* {dialogOpen && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <h2>Application has not been opened yet</h2>
            <button onClick={handleCloseDialog}>Close</button>
          </div>
        </div>
      )} */}
      {/* All your form JSX remains the same... */}
      {/* Make sure the <form> tag has onSubmit={handleSubmit} */}
      {/* And button has disabled={loading} */}
      <h2 className="form-heading">New Admission Application Form</h2>
      <form onSubmit={handleSubmit}>
        {/* Personal Information */}
        <h3 className="form-section-heading">Student Information</h3>
        <div className="form-group">
          <label htmlFor="fullName">Full Name:</label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Enter your name"
            required
          />
        </div>
        <div className="form-group">
        <label htmlFor="email">Email (optional):</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          onBlur={validateEmail}
          placeholder="Enter your email"
        />
        {emailError && <span className="error-text">{emailError}</span>}
      </div>
        <div className="form-group">
          <label htmlFor="dateOfBirth">Date of Birth:</label>
          <input
            type="date"
            id="dateOfBirth"
            name="dateOfBirth"
            value={formData.dateOfBirth}
            onChange={(e) => {
              handleChange(e);
              calculateAge(e.target.value);
            }}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="age">Age:</label>
          <input
            type="number"
            id="age"
            name="age"
            value={formData.age}
            onChange={handleChange}
            readOnly
          />
        </div>
        <div className="form-group">
        <label htmlFor="classSelection">Class:</label>
        <select 
          id="classSelection" 
          name="classSelection" 
          value={formData.classSelection}
          onChange={handleChange}
          required
        >
          <option value="">Select Class</option>
          {[...Array(10)].map((_, i) => (
            <option key={i + 1} value={i + 1}>
              Class {i + 1}
            </option>
          ))}
        </select>
      </div>
        <div className="form-group">
  <label htmlFor="phoneNumber">Phone Number:</label>
  <input
    type="tel"
    id="phoneNumber"
    name="phoneNumber"
    value={formData.phoneNumber}
    onChange={handleChange}
    placeholder="Enter your phone number"
    required
  />
  </div>

        <div className="form-group">
  <label>Gender:</label>
  <select 
    name="gender" 
    onChange={handleChange}
    className="form-select"
    required
  >
    <option value="">Select Gender</option>
    <option value="Male">Male</option>
    <option value="Female">Female</option>
  </select>
</div>
        <div className="form-group">
          <label htmlFor="address">Address:</label>
          <textarea
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            rows="3"
            required
          ></textarea>
        </div>
        
        {/* New Category Field */}
        <h3 className="form-section-heading">Category Information</h3>
        <div className="form-group">
          <label>Category:</label>
          <select
            id="category"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value="">Select Category</option>
            <option value="General">General</option>
            <option value="OBC">OBC</option>
            <option value="SC">SC</option>
            <option value="ST">ST</option>
            <option value="Others">Others</option>
          </select>
        </div>

        {/* Parent/Guardian Information */}
        <h3 className="form-section-heading">Parent/Guardian Information</h3>
        <div className="form-group">
          <label htmlFor="fatherName">Father's Name:</label>
          <input
            type="text"
            id="fatherName"
            name="fatherName"
            value={formData.fatherName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="fatherProfession">Father's Profession:</label>
          <input
            type="text"
            id="fatherProfession"
            name="fatherProfession"
            value={formData.fatherProfession}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="motherName">Mother's Name:</label>
          <input
            type="text"
            id="motherName"
            name="motherName"
            value={formData.motherName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="motherProfession">Mother's Profession:</label>
          <input
            type="text"
            id="motherProfession"
            name="motherProfession"
            value={formData.motherProfession}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="guardianName">Guardian's Name (if any):</label>
          <input
            type="text"
            id="guardianName"
            name="guardianName"
            value={formData.guardianName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="annualIncome">Parent/Guardian's Annual Income:</label>
          <input
            type="number"
            id="annualIncome"
            name="annualIncome"
            value={formData.annualIncome}
            onChange={handleChange}
          />
        </div>

        {/* Academic Details */}
        <h3 className="form-section-heading">Academic Details</h3>
        <div className="form-group">
          <label htmlFor="previousSchoolName">Previous School Name:</label>
          <input
            type="text"
            id="previousSchoolName"
            name="previousSchoolName"
            value={formData.previousSchoolName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="previousClass">Previous Class:</label>
          <input
            type="text"
            id="previousClass"
            name="previousClass"
            value={formData.previousClass}
            onChange={handleChange}
          />
        </div>

        {/* Medical Information */}
        <h3 className="form-section-heading">Medical Information</h3>
        <div className="form-group">
          <label htmlFor="medicalConditions">Medical Conditions:</label>
          <textarea
            id="medicalConditions"
            name="medicalConditions"
            value={formData.medicalConditions}
            onChange={handleChange}
            rows="3"
          ></textarea>
        </div>

        {/* File Uploads */}
        <h3 className="form-section-heading">Documents</h3>
        <div className="form-group">
          <label htmlFor="photoId">Photo ID:</label>
          <input
            type="file"
            id="photoId"
            name="photoId"
            onChange={handleFileChange}
            accept=".jpg, .jpeg, .png, .pdf"
          />
        </div>
        <div className="form-group">
          <label htmlFor="idProof">ID Proof:</label>
          <input
            type="file"
            id="idProof"
            name="idProof"
            onChange={handleFileChange}
            accept=".jpg, .jpeg, .png, .pdf"
          />
        </div>
        
        {/* Payment Details */}
        <h3 className="form-section-heading">Payment Details</h3>
        <div className="payment-details">
          <p className="payment-info">
            <strong>Bank Account Details:</strong>
            <br />
            A/C No: 11050100009935 <br />
            IFSC Code: PKGB0011050 <br />
            Bank Name: Karnataka Grameen Bank
          </p>
          <div className="qr-section">
            <img src={qrImage} alt="QR Code for Payment" className="qr-image" />
            <p className="qr-note">Scan the QR code to make the payment.</p>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="paymentTransactionId">Transaction ID:</label>
          <input
            type="text"
            id="paymentTransactionId"
            name="paymentTransactionId"
            value={formData.paymentTransactionId}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="paymentScreenshot">Upload Payment Screenshot:</label>
          <input
            type="file"
            id="paymentScreenshot"
            name="paymentScreenshot"
            onChange={handleFileChange}
            accept=".jpg, .jpeg, .png, .pdf"
            required
          />
        </div>

        <button type="submit" className="form-submit-button" disabled={loading}>
          {loading ? "Submitting..." : "Submit Application"}
        </button>
      </form>
    </div>
  );
}

export default NewApplicationForm;